module.exports = __webpack_public_path__ + "static/media/sdg-video.29137263.mp4";